import React from 'react';
import './StatutBadge.css';

// Statut tel qu'il apparait dans les listes des operations et des commandes : le TEXTE prend la
// couleur du statut (vert accepte, rouge refuse / expire / annule, orange action a mener, gris
// brouillon / en attente), sans fond. Meme classe `status-badge` et meme normalisation du libelle
// que les listes, pour un rendu identique.
interface StatutBadgeProps {
  libelle?: string | null;
}

/** « Brouillon acheteur » -> `brouillon-acheteur` : accents et apostrophes retires, espaces en tirets. */
const classeDe = (libelle: string): string =>
  libelle
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9-]/g, '')
    .toLowerCase();

const StatutBadge: React.FC<StatutBadgeProps> = ({ libelle }) => {
  if (!libelle) return <span>-</span>;
  return (
    <div className={`status-badge ${classeDe(libelle)}`} title={libelle}>
      {libelle}
    </div>
  );
};

export default StatutBadge;
